import {Component, ElementRef, HostListener, OnInit, OnDestroy} from '@angular/core';
import {UcaNavigationService} from '../../services/uca-navigation.service';
import {ParamService} from '../../services/param.service';
import {RewardsSummaryService} from '../../services/rewards-summary.service';
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';



declare var $: any;


@Component({
    selector: 'left-navigation',
    templateUrl: './left-navigation.component.html',
    styleUrls: ['./left-navigation.component.scss'],
    providers: [RewardsSummaryService]
})
export class LeftNavigationComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    KEYCODE_TAB: number = 9;
    leftNavOptions: any;
    leftNavOptionsList = [];
    banner: any;
    displayBanner: any;
    currentEnvironment: any;
    activatedRoute = '';
    menuTitleText = '';
    public showNav: Boolean = false;

    constructor(private hostElement: ElementRef, private ucaNavigationService: UcaNavigationService,
                private paramService: ParamService, private rewardsSummaryService: RewardsSummaryService,
                private router: Router, private authService: AuthService) {
    }

    ngOnInit() {
        this.banner = this.paramService.banner;
        this.displayBanner = this.paramService.displayBanner;
        this.currentEnvironment = this.rewardsSummaryService.getEnvironment();
        if (window.location.pathname.indexOf('dashboard') >= 0) {
            this.activatedRoute = 'dashboard';
        } else if (window.location.pathname.indexOf('partners') >= 0) {
            this.activatedRoute = 'partners';
        } else {
            this.activatedRoute = 'dashboard';
        }
        this.initSubscribes();
        if (this.leftNavOptionsList.length === 0) {
            this.ucaNavigationService.getLeftNavItems(this.banner, this.currentEnvironment);
        }
    }

    async initSubscribes() {
        this.ucaNavigationService.populateUcaNavigationSource$
            .pipe(takeUntil(this.destroy$))
            .subscribe(async (value) => {

            if (this.authService.checkB2B()) {
                this.leftNavOptionsList = [
                    { openPageMenu: 'false', menuLink: '/foru/coupons-deals.html', menuText: 'Deals+' },
                    { openPageMenu: 'false', menuLink: '/rewards/dashboard', menuText: 'Rewards', active: this.activatedRoute === 'dashboard' },
                    { openPageMenu: 'false', menuLink: '/foru/program-details.html', menuText: 'Program Details' },
                    { openPageMenu: 'false', menuLink: '/games/game-grid', menuText: 'Play & Earn' },
                    { openPageMenu: 'false', menuLink: '/rewards/partners', menuText: 'Partners offers', active: this.activatedRoute === 'partners' }
                ];
                this.leftNavOptions = { titleText: this.displayBanner + ' for U' };
                this.showNav = true;
            } else {
                
                if (value && value.root && value.root.responsivegrid && value.root.responsivegrid.left_navigation?.staticMenuItems) {
    
                    // Await experiment check BEFORE processing menu items
                    await this.getExperimentByIDAndRemoveLeftNavDiscovery(value);
    
                    // Reset list to prevent duplicates on re-trigger (e.g. back button)
                    this.leftNavOptionsList = [];
    
                    for (const key in value.root.responsivegrid.left_navigation.staticMenuItems) {
                        const menuItem = value.root.responsivegrid.left_navigation.staticMenuItems[key];
    
                        // Skip null/deleted items
                        if (!menuItem) continue;
    
                        menuItem.menuLink = menuItem.menuLink.replace(/\(banner\)/g, this.banner);
    
                        if (menuItem.menuLink.indexOf('dashboard') >= 0 || menuItem.menuLink.indexOf('foru/rewards') >= 0) {
                            menuItem.active = this.activatedRoute === 'dashboard';
                        } else if (menuItem.menuLink.indexOf('partners') >= 0) {
                            menuItem.active = this.activatedRoute === 'partners';
                        }
    
                        this.leftNavOptionsList.push(menuItem);
                    }
    
                    this.leftNavOptions = value.root.responsivegrid.left_navigation;
                    this.leftNavOptions.titleText = this.leftNavOptions.titleText.replace(/\(banner4U\)/g, this.displayBanner);
                    this.showNav = true;
                }
            }

        });
    }

    async getExperimentByIDAndRemoveLeftNavDiscovery(leftNavJson): Promise<void> {
        const EXPERIMENT_ID = 'ACIP548280';
        const sdk = window['AB']?.experimentation;
        const enableSavingsHubByBanner = window['SWY']?.CONFIGSERVICE?.featureToggleConfig?.enableSavingsHub;

        if (!sdk || typeof sdk.getExperimentByID !== 'function' || !enableSavingsHubByBanner) {
            this.removeDiscoveryItem(leftNavJson);
            return;
        }

        try {
            const response = await sdk.getExperimentByID(EXPERIMENT_ID, false);

            const features = Array.isArray(response?.features) ? response.features : [];
            const feature = features.find(f => f?.featureId === EXPERIMENT_ID) || null;

            if (!feature || !feature.eligible) {
                this.removeDiscoveryItem(leftNavJson);
                return;
            }

            switch (feature.group) {
                case 'B':
                case 'C':
                    // Keep discovery item for B and C
                    break;
                case 'A':
                default:
                    this.removeDiscoveryItem(leftNavJson);
                    break;
            }
        } catch {
            this.removeDiscoveryItem(leftNavJson);
        }
    }

    removeDiscoveryItem(leftNavJson) {
        const menuItems = leftNavJson?.root?.responsivegrid?.left_navigation?.staticMenuItems;
        if (menuItems) {
            for (const key in menuItems) {
                if (menuItems[key]?.menuLink?.indexOf('discovery') >= 0) {
                    delete menuItems[key];
                }
            }
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    analyticsEvents(navLink: String) {
        if (window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackPartnerNavLink) {
            window['AB']['DATALAYER'].trackPartnerNavLink(navLink);
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent): any {
        if (window.innerWidth <= 990) {
            if (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB) {
                let focusableEls = this.hostElement.nativeElement;
                let modalContent = $(focusableEls).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), input[type="ul"]:not([disabled]), input[type="li"]:not([disabled])');
                var firstFocusableEl = modalContent.first()[0];
                var lastFocusableEl = modalContent.last()[0];

                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }
            }
        }
    }

}
